/**
 * THIS FILE IS AUTOMATICALLY GENERATED.
 * If you edit it, any changes will be list.
 * This is generated by 'scripts/code/build-service-container.js'
 */

const AbstractServiceContainer = require('./AbstractServiceContainer');

class ServiceContainer extends AbstractServiceContainer {
    /**
     * @type {Function}
     */
    $timeout;

    /**
     * @type {any}
     */
    $rootScope;

    /**
     * @type {any}
     */
    $location;

    /**
     * @type {any}
     */
    dojoConfig;

    /**
     * @type {any}
     */
    verifoneConfig;

    /**
     * @type {any}
     */
    worldpayConfigService;

    /**
     * @type {AgentCashDrawerDriver}
     */
    agentCashDrawerDriver;

    /**
     * @type {AgentService}
     */
    agentService;

    /**
     * @type {ApiClient}
     */
    apiClient;

    /**
     * @type {ApiRequestParams}
     */
    apiRequestParams;

    /**
     * @type {AppConfig}
     */
    appConfig;

    /**
     * @type {AvailablePrintersManager}
     */
    availablePrintersManager;

    /**
     * @type {CartLineNumberFactory}
     */
    cartLineNumberFactory;

    /**
     * @type {CartLineSplitter}
     */
    cartLineSplitter;

    /**
     * @type {CartService}
     */
    cartService;

    /**
     * @type {CartStasher}
     */
    cartStasher;

    /**
     * @type {CartStashHelper}
     */
    cartStashHelperService;

    /**
     * @type {CartToConfirmationStructureMapper}
     */
    cartToConfirmationStructureMapper;

    /**
     * @type {CartToOrderMapper}
     */
    cartToOrderMapper;

    /**
     * @type {CartToReservationStructureMapper}
     */
    cartToReservationStructureMapper;

    /**
     * @type {CashDrawerService}
     */
    cashDrawerService;

    /**
     * @type {CategoryRepository}
     */
    categoryRepository;

    /**
     * @type {CheckoutService}
     */
    checkoutService;

    /**
     * @type {ClubcardService}
     */
    clubcardService;

    /**
     * @type {ClubcardTokenApplicator}
     */
    clubcardTokenApplicator;

    /**
     * @type {ConnectivityChecker}
     */
    connectivityChecker;

    /**
     * @type {ContactService}
     */
    contactService;

    /**
     * @type {CountryManager}
     */
    countryManager;

    /**
     * @type {CurrencyService}
     */
    currencyService;

    /**
     * @type {CurrentDevice}
     */
    currentDevice;

    /**
     * @type {CustomerAccountService}
     */
    customerAccountService;

    /**
     * @type {CustomerScreenDataService}
     */
    customerScreenDataService;

    /**
     * @type {DataStoreTester}
     */
    dataStoreTester;

    /**
     * @type {DeviceLockService}
     */
    deviceLockService;

    /**
     * @type {DeviceLoginListener}
     */
    deviceLoginListener;

    /**
     * @type {DeviceManager}
     */
    deviceManager;

    /**
     * @type {DialogService}
     */
    dialogService;

    /**
     * @type {EntraIDAuthService}
     */
    entraIDAuthService;

    /**
     * @type {ErrorPresenter}
     */
    errorPresenter;

    /**
     * @type {EInvoicingService}
     */
    eInvoicingService;

    /**
     * @type {EventBus}
     */
    eventBus;

    /**
     * @type {EventsByCategoryService}
     */
    eventsByCategoryService;

    /**
     * @type {ExternalCartCalculator}
     */
    externalCartCalculator;

    /**
     * @type {FieldDataService}
     */
    fieldDataService;

    /**
     * @type {FieldInstanceFactory}
     */
    fieldInstanceFactory;

    /**
     * @type {FieldRepository}
     */
    fieldRepository;

    /**
     * @type {FieldValidator}
     */
    fieldValidator;

    /**
     * @type {GiftAidPrompter}
     */
    giftAidPrompter;

    /**
     * @type {GiftAidRateRepository}
     */
    giftAidRateRepository;

    /**
     * @type {GiftVoucherRepository}
     */
    giftVoucherRepository;

    /**
     * @type {GiftVoucherValidator}
     */
    giftVoucherValidator;

    /**
     * @type {GoCardlessService}
     */
    goCardlessService;

    /**
     * @type {Hydrator}
     */
    hydrator;

    /**
     * @type {ImageRepository}
     */
    imageRepository;

    /**
     * @type {ItemBarcodeRepository}
     */
    itemBarcodeRepository;

    /**
     * @type {ItemBarcodeService}
     */
    itemBarcodeService;

    /**
     * @type {ItemInstanceOrderMapRepository}
     */
    itemInstanceOrderMapRepository;

    /**
     * @type {ItemOptionConfigValidator}
     */
    itemOptionConfigValidator;

    /**
     * @type {ItemOptionManager}
     */
    itemOptionManager;

    /**
     * @type {ItemOptionRepository}
     */
    itemOptionRepository;

    /**
     * @type {ItemRepository}
     */
    itemRepository;

    /**
     * @type {KeyboardInputDetector}
     */
    keyboardInputDetector;

    /**
     * @type {KitchenOrderFactory}
     */
    kitchenOrderFactory;

    /**
     * @type {KitchenZoneRepository}
     */
    kitchenZoneRepository;

    /**
     * @type {KitchenReceiptPrinter}
     */
    kitchenReceiptPrinter;

    /**
     * @type {KitchenService}
     */
    kitchenService;

    /**
     * @type {LandingPageService}
     */
    landingPageService;

    /**
     * @type {LangService}
     */
    langService;

    /**
     * @type {LocalStorageDataStore}
     */
    localStorageDataStore;

    /**
     * @type {LoginService}
     */
    loginService;

    /**
     * @type {LogoService}
     */
    logoService;

    /**
     * @type {MarketingPreferenceAsker}
     */
    marketingPreferenceAsker;

    /**
     * @type {MarketingPreferenceRepository}
     */
    marketingPreferenceRepository;

    /**
     * @type {MembershipCancellationRunner}
     */
    membershipCancellationRunner;

    /**
     * @type {MembershipManagementService}
     */
    membershipManagementService;

    /**
     * @type {MembershipPlanRepository}
     */
    membershipPlanRepository;

    /**
     * @type {MembershipRedemptionService}
     */
    membershipRedemptionService;

    /**
     * @type {MembershipRefGenerator}
     */
    membershipRefGenerator;

    /**
     * @type {MembershipService}
     */
    membershipService;

    /**
     * @type {MembershipValidator}
     */
    membershipValidator;

    /**
     * @type {MellonWebECRDriver}
     */
    mellonWebECRDriver;

    /**
     * @type {ModalFactory}
     */
    modalFactory;

    /**
     * @type {NavigationService}
     */
    navigationService;

    /**
     * @type {NumPadFactory}
     */
    numPadFactory;

    /**
     * @type {OfferApplicator}
     */
    offerApplicator;

    /**
     * @type {OfferRepository}
     */
    offerRepository;

    /**
     * @type {OfferService}
     */
    offerService;

    /**
     * @type {OptionSetRepository}
     */
    optionSetRepository;

    /**
     * @type {OnlineQueue}
     */
    onlineQueue;

    /**
     * @type {OnlineTaskRepository}
     */
    onlineTaskRepository;

    /**
     * @type {OrderAdjustmentConfirmer}
     */
    orderAdjustmentConfirmer;

    /**
     * @type {OrderConfirmer}
     */
    orderConfirmer;

    /**
     * @type {OrderDownloader}
     */
    orderDownloader;

    /**
     * @type {OrderFieldInstancesFromApiBuilder}
     */
    orderFieldInstancesFromApiBuilder;

    /**
     * @type {OrderFulfillmentService}
     */
    orderFulfillmentService;

    /**
     * @type {OrderInProgressStasher}
     */
    orderInProgressStasher;

    /**
     * @type {OrderQueue}
     */
    orderQueue;

    /**
     * @type {OrderReceiptPrinter}
     */
    orderReceiptPrinter;

    /**
     * @type {OrderRelationAttacher}
     */
    orderRelationAttacher;

    /**
     * @type {OrderRepository}
     */
    orderRepository;

    /**
     * @type {OrderRequestSubmitter}
     */
    orderRequestSubmitter;

    /**
     * @type {OrdersApi}
     */
    ordersApi;

    /**
     * @type {OrderSearcher}
     */
    orderSearcher;

    /**
     * @type {OrderService}
     */
    orderService;

    /**
     * @type {PaymentExpressDriver}
     */
    paymentExpressDriver;

    /**
     * @type {PaymentMethodService}
     */
    paymentMethodService;

    /**
     * @type {PaymentService}
     */
    paymentService;

    /**
     * @type {PaymentState}
     */
    paymentState;

    /**
     * @type {PricingRuleCalculator}
     */
    pricingRuleCalculator;

    /**
     * @type {Printer}
     */
    printer;

    /**
     * @type {PrinterAppPrintDriver}
     */
    printerAppPrintDriver;

    /**
     * @type {PrintRouter}
     */
    printRouter;

    /**
     * @type {PrivilegesManager}
     */
    privilegesManager;

    /**
     * @type {PrivilegesRepository}
     */
    privilegesRepository;

    /**
     * @type {ProductAvailabilityChecker}
     */
    productAvailabilityChecker;

    /**
     * @type {ProductRepository}
     */
    productRepository;

    /**
     * @type {ReceiptPrinter}
     */
    receiptPrinter;

    /**
     * @type {RedemptionScanHandler}
     */
    redemptionScanHandler;

    /**
     * @type {RedemptionService}
     */
    redemptionService;

    /**
     * @type {RefValidator}
     */
    refValidator;

    /**
     * @type {ReservationService}
     */
    reservationService;

    /**
     * @type {ReturnReasonRepository}
     */
    returnReasonRepository;

    /**
     * @type {SaleableItemService}
     */
    saleableItemService;

    /**
     * @type {SavedAddressManager}
     */
    savedAddressManager;

    /**
     * @type {SearchContext}
     */
    searchContext;

    /**
     * @type {SellService}
     */
    sellService;

    /**
     * @type {SessionAvailabilityService}
     */
    sessionAvailabilityService;

    /**
     * @type {SessionCalendarPopulator}
     */
    sessionCalendarPopulator;

    /**
     * @type {SessionEventRepository}
     */
    sessionEventRepository;

    /**
     * @type {SessionRepository}
     */
    sessionRepository;

    /**
     * @type {SessionSpaceCalculatorFactory}
     */
    sessionSpaceCalculatorFactory;

    /**
     * @type {SoldGiftVoucherManager}
     */
    soldGiftVoucherManager;

    /**
     * @type {StaffRefValidator}
     */
    staffRefValidator;

    /**
     * @type {StashMetadataService}
     */
    stashMetadataService;

    /**
     * @type {SyncedDataManager}
     */
    syncedDataManager;

    /**
     * @type {SyncRunner}
     */
    syncRunner;

    /**
     * @type {SyncStateManager}
     */
    syncStateManager;

    /**
     * @type {TaxManager}
     */
    taxManager;

    /**
     * @type {TemplateCompiler}
     */
    templateCompiler;

    /**
     * @type {TemplateRepository}
     */
    templateRepository;

    /**
     * @type {ThemeManager}
     */
    themeManager;

    /**
     * @type {ThirdPartyRefGenerator}
     */
    thirdPartyRefGenerator;

    /**
     * @type {TicketRedeemer}
     */
    ticketRedeemer;

    /**
     * @type {TicketRepository}
     */
    ticketRepository;

    /**
     * @type {TimeSyncer}
     */
    timeSyncer;

    /**
     * @type {ToastFactory}
     */
    toastFactory;

    /**
     * @type {TradingSessionManager}
     */
    tradingSessionManager;

    /**
     * @type {UserService}
     */
    userService;

    /**
     * @type {UserSessionManager}
     */
    userSessionManager;

    /**
     * @type {UserSwitcher}
     */
    userSwitcher;

    /**
     * @type {VueModalFactory}
     */
    vueModalFactory;

    /**
     * @type {VuexService}
     */
    vuexService;

    /**
     * @type {WaiversService}
     */
    waiversService;

    /**
     * @type {WebsocketService}
     */
    websocketService;

    /**
     * @type {any}
     */
    cartCalculationResource;

    /**
     * @type {any}
     */
    categoryResource;

    /**
     * @type {any}
     */
    customerAccountsResource;

    /**
     * @type {any}
     */
    deviceResource;

    /**
     * @type {any}
     */
    fieldResource;

    /**
     * @type {any}
     */
    giftVoucherResource;

    /**
     * @type {any}
     */
    logResource;

    /**
     * @type {any}
     */
    marketingPreferenceResource;

    /**
     * @type {any}
     */
    membershipPlanResource;

    /**
     * @type {any}
     */
    membershipRedemptionResource;

    /**
     * @type {any}
     */
    membershipResource;

    /**
     * @type {any}
     */
    membershipSubscriptionResource;

    /**
     * @type {any}
     */
    orderResource;

    /**
     * @type {any}
     */
    partialRefundPaymentResource;

    /**
     * @type {any}
     */
    paymentExpressResource;

    /**
     * @type {any}
     */
    paymentResource;

    /**
     * @type {any}
     */
    privilegesResource;

    /**
     * @type {any}
     */
    productAvailabilityResource;

    /**
     * @type {any}
     */
    productResource;

    /**
     * @type {any}
     */
    redemptionResource;

    /**
     * @type {any}
     */
    returnReasonResource;

    /**
     * @type {any}
     */
    savedAddressResource;

    /**
     * @type {any}
     */
    sessionPriceResource;

    /**
     * @type {any}
     */
    soldGiftVoucherResource;

    /**
     * @type {any}
     */
    stashedCartResource;

    /**
     * @type {any}
     */
    templateResource;

    /**
     * @type {any}
     */
    ticketResource;

    /**
     * @type {any}
     */
    tradingSessionResource;

    /**
     * @type {any}
     */
    userResource;

    /**
     * @type {CloverDriver}
     */
    cloverDriver;

    /**
     * @type {DojoDriver}
     */
    dojoDriver;

    /**
     * @type {PayyoDriver}
     */
    payyoDriver;

    /**
     * @type {PayyoWebSocketClient}
     */
    payyoWebSocketClient;

    /**
     * @type {VerifoneAuthHandler}
     */
    verifoneAuthHandler;

    /**
     * @type {VerifoneDriver}
     */
    verifoneDriver;

    /**
     * @type {VerifoneResponseRecordFactory}
     */
    verifoneResponseRecordFactory;

    /**
     * @type {WorldpayDriver}
     */
    worldpayDriverService;
}

module.exports = ServiceContainer;
